import { useState } from "react";
import {
  FaEnvelopeOpenText,
  FaLocationArrow,
  FaPhoneAlt,
} from "react-icons/fa";

function Faq() {
  const [activeQ, setActiveQ] = useState("");
  const openQ = (id) => {
    setActiveQ(activeQ === id ? "" : id);
  };
  const getClassAnswer = (id) => {
    return activeQ === id ? "active-answer" : "";
  };
  const getClassQuestion = (id) => {
    return activeQ === id ? "active-question" : "";
  };
  const emailAddress = "info@ezcarrentals.com.au";
  const phoneNumber = "0400920512";
  return (
    <>
      <section className='faq-section'>
        <div className='container'>
          <div className='faq-content'>
            <div className='faq-content__title'>
              <h3>FAQ</h3>
              <h2>Frequently asked questions when renting with us</h2>
            </div>
            <div className='all-questions'>
              <div className='faq-box'>
                <div
                  id='q1'
                  onClick={() => openQ("q1")}
                  className={`faq-box__question  ${getClassQuestion("q1")}`}
                >
                  <p>1. How do I book a car?</p>
                  <i className='fa-solid fa-angle-down'></i>
                </div>
                <div
                  id='q1'
                  onClick={() => openQ("q1")}
                  className={`faq-box__answer ${getClassAnswer("q1")}`}
                >
                  Once you send us an enquiry (through phone/website/email) our
                  friendly staff will get back to you with availability and
                  pricing. To confirm your booking, we require a minimum $100.00
                  (non-refundable deposit). This deposit is credited to your
                  rental. Payments can be made via bank card/ bank transfer or
                  PAY ID or cash.
                </div>
              </div>
              <div className='faq-box'>
                <div
                  id='q2'
                  onClick={() => openQ("q2")}
                  className={`faq-box__question ${getClassQuestion("q2")}`}
                >
                  <p>2. How old do I need to be to rent a car?</p>
                  <i className='fa-solid fa-angle-down'></i>
                </div>
                <div
                  id='q2'
                  onClick={() => openQ("q2")}
                  className={`faq-box__answer ${getClassAnswer("q2")}`}
                >
                  We allow all drivers over the age of 21. Probationary license
                  holders may incur additional rental charges. All drivers
                  require a valid driver’s license.
                </div>
              </div>
              <div className='faq-box'>
                <div
                  id='q3'
                  onClick={() => openQ("q3")}
                  className={`faq-box__question ${getClassQuestion("q3")}`}
                >
                  <p>3. What documents do I need to rent a car?</p>
                  <i className='fa-solid fa-angle-down'></i>
                </div>
                <div
                  id='q3'
                  onClick={() => openQ("q3")}
                  className={`faq-box__answer ${getClassAnswer("q3")}`}
                >
                  <li>Driver’s License</li>
                  <li>Bank Card (Credit/Debit)</li>
                  <li>
                    Secondary proof of address (utility bill/lease agreement)
                  </li>
                </div>
              </div>
              <div className='faq-box'>
                <div
                  id='q4'
                  onClick={() => openQ("q4")}
                  className={`faq-box__question ${getClassQuestion("q4")}`}
                >
                  <p>4. Are there any hidden charges or fees?</p>
                  <i className='fa-solid fa-angle-down'></i>
                </div>
                <div
                  id='q4'
                  onClick={() => openQ("q4")}
                  className={`faq-box__answer ${getClassAnswer("q4")}`}
                >
                  We are a transparent company with no hidden fees. All fees are
                  outlines on our rental agreement. <br />
                  For traffic fines/tolls we charge a $33 nomination fee. <br />
                  We also have a strict non-smoking policy in all our cars.
                  Smoking in cars may incur cleaning fees of min $150.00
                </div>
              </div>
              <div className='faq-box'>
                <div
                  id='q5'
                  onClick={() => openQ("q5")}
                  className={`faq-box__question ${getClassQuestion("q5")}`}
                >
                  <p>5. Can I add an additional driver?</p>
                  <i className='fa-solid fa-angle-down'></i>
                </div>
                <div
                  id='q5'
                  onClick={() => openQ("q5")}
                  className={`faq-box__answer ${getClassAnswer("q5")}`}
                >
                  One additional driver can be added at no extra cost.
                </div>
              </div>

              <div className='faq-box'>
                <div
                  id='q6'
                  onClick={() => openQ("q6")}
                  className={`faq-box__question ${getClassQuestion("q6")}`}
                >
                  <p>6. What happens if I return the car late?</p>
                  <i className='fa-solid fa-angle-down'></i>
                </div>
                <div
                  id='q6'
                  onClick={() => openQ("q6")}
                  className={`faq-box__answer ${getClassAnswer("q6")}`}
                >
                  We allow after hours drop off – please arrange with our
                  friendly staff. <br />
                  $10.00 per hour will be charged per additional hour.
                </div>
              </div>

       
              <div className='faq-box'>
  <div
    id='q7'
    onClick={() => openQ("q7")}
    className={`faq-box__question ${getClassQuestion("q7")}`}
  >
    <p>7. Can I modify or cancel my reservation?</p>
    <i className='fa-solid fa-angle-down'></i>
  </div>
  <div
    id='q7'
    onClick={() => openQ("q7")}
    className={`faq-box__answer ${getClassAnswer("q7")}`}
  >
    You can call us anytime to extend or return your car. Any cancellations on a reserved car may incur the minimum $100.00 advance payment not being refunded.
     Once a car has been paid for and picked up, we do not refund on early returns.
  </div>
</div>

<div className='faq-box'>
  <div
    id='q8'
    onClick={() => openQ("q8")}
    className={`faq-box__question ${getClassQuestion("q8")}`}
  >
    <p>8. Are there any mileage restrictions?</p>
    <i className='fa-solid fa-angle-down'></i>
  </div>
  <div
    id='q8'
    onClick={() => openQ("q8")}
    className={`faq-box__answer ${getClassAnswer("q8")}`}
  >
    Commercial vehicles (Utes and vans) – 150 km per day<br />
    Cars and SUVs - 200 km per day
  </div>
</div>

<div className='faq-box'>
  <div
    id='q9'
    onClick={() => openQ("q9")}
    className={`faq-box__question ${getClassQuestion("q9")}`}
  >
    <p>9. What do I do in case of an accident?</p>
    <i className='fa-solid fa-angle-down'></i>
  </div>
  <div
    id='q9'
    onClick={() => openQ("q9")}
    className={`faq-box__answer ${getClassAnswer("q9")}`}
  >
    In case of a not-at-fault accident, the hirer is responsible for getting all details of the at-fault party, including driver’s license, name, address, insurance company details, photos of our car and the at-fault car, registration of the at-fault car, and claim number.<br /><br />
    Please call us on <b> 0400920512 </b> and advise of the accident.
  </div>
</div>

<div className='faq-box'>
  <div
    id='q10'
    onClick={() => openQ("q10")}
    className={`faq-box__question ${getClassQuestion("q10")}`}
  >
    <p>10. What do I do in case of a breakdown?</p>
    <i className='fa-solid fa-angle-down'></i>
  </div>
  <div
    id='q10'
    onClick={() => openQ("q10")}
    className={`faq-box__answer ${getClassAnswer("q10")}`}
  >
    Please call our office on <b> 0400920512 </b> or text/email us. Our friendly staff will get back to you ASAP. Our towing policy in case a vehicle needs towing covers 40 km free of charge. Any additional km will be charged to you.
  </div>
</div>

<div className='faq-box'>
  <div
    id='q11'
    onClick={() => openQ("q11")}
    className={`faq-box__question ${getClassQuestion("q11")}`}
  >
    <p>11. Can I rent long term?</p>
    <i className='fa-solid fa-angle-down'></i>
  </div>
  <div
    id='q11'
    onClick={() => openQ("q11")}
    className={`faq-box__answer ${getClassAnswer("q11")}`}
  >
    Long term leases/rentals can be organized at discounted rates. We consider 4 weeks or more to be long term. Please enquire with our friendly staff.
  </div>
</div>

<div className='faq-box'>
  <div
    id='q12'
    onClick={() => openQ("q12")}
    className={`faq-box__question ${getClassQuestion("q12")}`}
  >
    <p>12. Can I travel interstate?</p>
    <i className='fa-solid fa-angle-down'></i>
  </div>
  <div
    id='q12'
    onClick={() => openQ("q12")}
    className={`faq-box__answer ${getClassAnswer("q12")}`}
  >
    Unfortunately, we don’t allow interstate travel at this stage. We hope to relax this once we grow to have several branches.
  </div>
</div>

<div className='faq-box'>
  <div
    id='q13'
    onClick={() => openQ("q13")}
    className={`faq-box__question ${getClassQuestion("q13")}`}
  >
    <p>13. How much is the bond/deposit?</p>
    <i className='fa-solid fa-angle-down'></i>
  </div>
  <div
    id='q13'
    onClick={() => openQ("q13")}
    className={`faq-box__answer ${getClassAnswer("q13")}`}
  >
    We hold a fully refundable bond of $500 for all rentals. To receive your bond back in full, please return the vehicle clean, with the same fuel level as at pickup, and without any new damage or outstanding fees.
  </div>
</div>

<div className='faq-box'>
  <div
    id='q14'
    onClick={() => openQ("q14")}
    className={`faq-box__question ${getClassQuestion("q14")}`}
  >
    <p>14. When will I receive my bond/deposit back?</p>
    <i className='fa-solid fa-angle-down'></i>
  </div>
  <div
    id='q14'
    onClick={() => openQ("q14")}
    className={`faq-box__answer ${getClassAnswer("q14")}`}
  >
    In most cases, we aim to refund your bond on the same day the vehicle is returned. While this happens around 99% of the time, please allow up to 48 hours for the refund to be processed.
  </div>
</div>




            </div>
          </div>
        </div>
      </section>
      <section className='contact-page'>
        <div className='container'>
          <div className=' '>
            <div className='contact-div__text'>
              <h2>Need additional information?</h2>
              <p>
                Feel free to call us. If we don't answer leave us a text and we
                will get back to you as soon as possible.
              </p>
              <a href={`tel:${phoneNumber}`}>
                <FaPhoneAlt />
                &nbsp; {phoneNumber}
              </a>
              <a href={`mailto:${emailAddress}`}>
                <FaEnvelopeOpenText /> &nbsp;
                {emailAddress}
              </a>
              <a href='https://maps.google.com/?q=33B+Clifford+Street,+Huntingdale+VIC+3166'>
                <FaLocationArrow /> &nbsp;33B Clifford street, Huntingdale VIC 3166
              </a>
            </div>
            <div className='contact-div__form'>
              <iframe
                title='Google Map'
                src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3149.3377352649622!2d145.10061171232203!3d-37.87578367184331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad615a21604a335%3A0xde8f69d98bc937ea!2sEZ%20Car%20Rentals%20-%20Van%20Ute%20and%20Car%20Hire!5e0!3m2!1sen!2slk!4v1707201190933!5m2!1sen!2slk'
                width='100%'
                height='450'
                style={{ border: 0, marginTop: "20px", marginBottom: "20px" }}
                allowFullScreen=''
                loading='lazy'
                referrerPolicy='no-referrer-when-downgrade'
              ></iframe>
            </div>
          </div>
        </div>
        <div className='book-banner'>
          <div className='book-banner__overlay'></div>
          <div className='container'>
            <div className='text-content'>
              <h2>Book a car by getting in touch with us </h2>
              <span>
                {/* <a href={`tel:${phoneNumber}`}>
  <FaHeadphonesAlt    />&nbsp; {phoneNumber}
</a> */}
                <button className='call-new-btn'>
                  <FaPhoneAlt className='phone-icon' />
                  {phoneNumber}
                </button>
              </span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq;
